import config from "./config"
import HttpClient from "./utils/HttpClient"
import ErrorHandler from "./utils/ErrorHandler"
import AuthClient from "./utils/AuthClient"
import AuthService from "./services/AuthService"
import AdminUserService from "./services/admin/UserService"
import AdminImportedUserService from "./services/admin/ImportedUserService"
import AdminProductService from "./services/admin/ProductService"

// Утилиты
const authClient = new AuthClient(config.authClient)
const httpClient = new HttpClient({ ...config.httpClient, token: () => authClient.getToken() })
const errorHandler = new ErrorHandler(config.errorHandler)

// Сервисы
const authService = new AuthService(authClient, httpClient, errorHandler)
const adminUserService = new AdminUserService(httpClient, errorHandler)
const adminImportedUserService = new AdminImportedUserService(httpClient, errorHandler)
const adminProductService = new AdminProductService(httpClient, errorHandler)

export default {
	// Конфигурация
	config,

	// Утилиты
	authClient,
	httpClient,
	errorHandler,

	// Сервисы
	authService,
	adminUserService,
	adminImportedUserService,
	adminProductService
}
